import { asyncConnect } from 'redux-connect';
import { translate } from 'react-i18next';
import { createStructuredSelector } from 'reselect';

import {
  clearSearchResults,
  clearSearchResultsMap,
  loadSearchResults,
  loadSearchResultsMap
} from 'actions';
import {
  bikeTypesSelector,
  countriesSelector,
  currencySelector,
  searchResultsIsFetching,
  searchResultsMapIsFetchingSelector,
  searchResultsMapItemsSelector,
  searchResultsSelector
} from 'selectors';
import {
  isModeratorSelector
} from 'selectors/profile';
import {
  buildApiParams,
  buildSearchParams,
  createPromise
} from 'utils';

import SearchPage from './SearchPage';

import './SearchPage.css';

const mapStateToProps = createStructuredSelector({
  currency: currencySelector,
  countries: countriesSelector,
  bikeTypes: bikeTypesSelector,
  searchResults: searchResultsSelector,
  searchResultsMap: searchResultsMapItemsSelector,
  isFetchingList: searchResultsIsFetching,
  isFetchingMap: searchResultsMapIsFetchingSelector,
  isModerator: isModeratorSelector
});

const mapDispatchToProps = {
  loadSearchResults,
  clearSearchResults,
  loadSearchResultsMap,
  clearSearchResultsMap
};

export default asyncConnect(
  [{
    promise: ({
      store,
      location: { query },
      helpers: { shouldWait }
    }) => {
      if (!query) {
        return;
      }

      const state = store.getState();

      const countries = countriesSelector(state);
      const params = buildApiParams(buildSearchParams(query, countries));

      store.dispatch(clearSearchResults());

      return createPromise(
        store,
        shouldWait,
        searchResultsSelector,
        loadSearchResults,
        params
      );
    }
  }],
  mapStateToProps,
  mapDispatchToProps
)(translate(['search', 'translation', 'cities'])(SearchPage));



// WEBPACK FOOTER //
// ./src/components/SearchPage/index.js